// @owners { team: patients }

/**
 * True when the error indicates browser / localStorage quota was exceeded.
 * (MMKV on web is backed by localStorage and throws the same DOMException.)
 */
export function isQuotaExceededError(error: unknown): boolean {
  if (error === null || typeof error !== 'object') {
    return false;
  }
  const { name, code } = error as { name?: string; code?: number };
  if (name === 'QuotaExceededError' || name === 'NS_ERROR_DOM_QUOTA_REACHED') {
    return true;
  }
  // Legacy DOMException code for quota exceeded
  return code === 22;
}
